(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function withDelimiters(number, precision, thousands, decimal) {
    precision = typeof precision === 'undefined' ? 2 : precision;
    thousands = typeof thousands === 'undefined' ? ',' : thousands;
    decimal = typeof decimal === 'undefined' ? '.' : decimal;
    if (isNaN(number) || number == null) return '0';
    number = (number / 100).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  function formatMoney(cents) {
    var format = window.ShorreFindsMoneyFormat || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2); break;
    }
    return format.replace(match[0], value);
  }

  function initProductSection(section) {
    var form = qs('[data-product-form]', section);
    if (!form) return;

    var variantsJSON = qs('[data-product-json]', form);
    var variants = variantsJSON ? JSON.parse(variantsJSON.textContent) : [];
    var optionFieldsets = qsa('.option-selector', form);
    var idInput = qs('[data-variant-id]', form);
    var mobileBar = qs('[data-mobile-buy-bar]');
    var priceEls = qsa('[data-product-price]', section).concat(mobileBar ? qsa('[data-mobile-buy-bar-price]', mobileBar) : []);
    var availabilityEl = qs('[data-product-availability]', section);
    var addButtons = qsa('[data-add-to-cart]', section).concat(mobileBar ? qsa('[data-mobile-add-to-cart]', mobileBar) : []);
    var addButtonTexts = qsa('[data-add-to-cart-text]', section).concat(mobileBar ? qsa('[data-add-to-cart-text]', mobileBar) : []);
    var gallery = qs('[data-product-gallery]', section);

    function getSelectedOptions() {
      return optionFieldsets.map(function (fieldset) {
        var checked = qs('input[data-option-input]:checked', fieldset);
        return checked ? checked.value : null;
      });
    }

    function findVariant(selected) {
      return variants.find(function (variant) {
        return selected.every(function (value, i) {
          return value === null || variant.options[i] === value;
        });
      });
    }

    function updateAvailability() {
      optionFieldsets.forEach(function (fieldset, index) {
        var selected = getSelectedOptions();
        qsa('input[data-option-input]', fieldset).forEach(function (input) {
          var testSelection = selected.slice();
          testSelection[index] = input.value;
          var match = findVariant(testSelection);
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !match || match.available === false);
        });
      });
    }

    function setMedia(mediaId) {
      if (!gallery || !mediaId) return;
      qsa('[data-media-item]', gallery).forEach(function (item) {
        item.classList.toggle('is-active', String(item.getAttribute('data-media-id')) === String(mediaId));
      });
      qsa('[data-thumb]', gallery).forEach(function (thumb) {
        var active = String(thumb.getAttribute('data-media-id')) === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function updateUI(variant) {
      if (!variant) {
        addButtons.forEach(function (btn) { btn.disabled = true; });
        addButtonTexts.forEach(function (el) { el.textContent = window.ShorreFindsStrings && window.ShorreFindsStrings.unavailable ? window.ShorreFindsStrings.unavailable : 'Unavailable'; });
        return;
      }

      if (idInput) idInput.value = variant.id;

      priceEls.forEach(function (el) {
        var compareAt = variant.compare_at_price;
        var price = variant.price;
        var html = '';
        if (compareAt && compareAt > price) {
          html = '<s class="price__compare">' + formatMoney(compareAt) + '</s><span class="price--sale">' + formatMoney(price) + '</span>';
        } else {
          html = '<span class="price__regular">' + formatMoney(price) + '</span>';
        }
        var priceWrap = el.querySelector('.price') || el;
        priceWrap.innerHTML = html;
      });

      if (availabilityEl) {
        var strings = window.ShorreFindsStrings || {};
        if (!variant.available) {
          availabilityEl.textContent = strings.soldOut || availabilityEl.textContent;
          availabilityEl.dataset.state = 'unavailable';
        } else if (variant.inventory_management === 'shopify' && variant.inventory_quantity <= 5 && variant.inventory_quantity > 0) {
          availabilityEl.textContent = (strings.lowStock || 'Only %d left').replace('%d', variant.inventory_quantity);
          availabilityEl.dataset.state = 'low';
        } else {
          availabilityEl.textContent = strings.inStock || availabilityEl.textContent;
          availabilityEl.dataset.state = 'available';
        }
      }

      addButtons.forEach(function (btn) { btn.disabled = !variant.available; });
      addButtonTexts.forEach(function (el) {
        if (!variant.available && window.ShorreFindsStrings) el.textContent = window.ShorreFindsStrings.soldOut || 'Sold Out';
        else if (window.ShorreFindsStrings) el.textContent = window.ShorreFindsStrings.addToBag || 'Add to Bag';
      });

      if (variant.featured_image) {
        setMedia(variant.featured_image.id);
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }

      updateAvailability();
    }

    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-input]')) return;
      var selected = getSelectedOptions();
      var variant = findVariant(selected);
      updateUI(variant);
    });

    /* Quantity stepper (scoped to this form) */
    form.addEventListener('click', function (e) {
      var input = qs('[data-qty-input]', form);
      if (!input) return;
      if (e.target.closest('[data-qty-increase]')) {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + 1);
      }
      if (e.target.closest('[data-qty-decrease]')) {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      }
    });

    updateAvailability();
  }

  function initGalleryZoom(section) {
    var main = qs('[data-product-main-media]', section);
    if (!main) return;
    main.addEventListener('click', function (e) {
      if (e.target.closest('model-viewer, video, iframe')) return;
      main.classList.toggle('is-zoomed');
    });
  }

  function initThumbs(section) {
    var thumbs = qsa('[data-thumb]', section);
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaId = thumb.getAttribute('data-media-id');
        qsa('[data-media-item]', section).forEach(function (item) {
          item.classList.toggle('is-active', String(item.getAttribute('data-media-id')) === String(mediaId));
        });
        thumbs.forEach(function (t) {
          var active = t === thumb;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      });
    });
  }

  function initSizeGuide() {
    var modal = qs('[data-size-guide-modal]');
    var openers = qsa('[data-size-guide-open]');
    if (!modal || !openers.length) return;
    var release = null;

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        if (window.ShorreFinds && window.ShorreFinds.trapFocus) {
          release = window.ShorreFinds.trapFocus(qs('.size-guide-modal__panel', modal));
        }
      });
    });

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if (release) release();
    }

    qsa('[data-size-guide-close]', modal).forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  function initMobileBuyBar(section) {
    var bar = qs('[data-mobile-buy-bar]');
    var trigger = qs('[data-add-to-cart]', section);
    if (!bar || !trigger || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.hidden = entry.isIntersecting;
      });
    }, { rootMargin: '0px 0px -20% 0px' });
    observer.observe(trigger);
  }

  function init() {
    qsa('[data-product-section]').forEach(function (section) {
      initProductSection(section);
      initGalleryZoom(section);
      initThumbs(section);
      initMobileBuyBar(section);
    });
    initSizeGuide();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-product-section]');
    if (section) {
      initProductSection(section);
      initGalleryZoom(section);
      initThumbs(section);
      initMobileBuyBar(section);
      initSizeGuide();
    }
  });
})();
